import { render, staticRenderFns } from "./UserTeam.vue?vue&type=template&id=4b9a9ff8&scoped=true"
import script from "./UserTeam.vue?vue&type=script&lang=js"
export * from "./UserTeam.vue?vue&type=script&lang=js"
import style0 from "./UserTeam.vue?vue&type=style&index=0&id=4b9a9ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9a9ff8",
  null
  
)

export default component.exports